export { default } from './Component'